import { FC } from "react";
import Views from "../../../../assets/icon/Views";

interface Props {
  publicationDate: string;
}

const PagesByIdAnalyst: FC<Props> = ({ publicationDate }) => {
  return (
    <>
      <div className="flex items-center text-sm">
        <span className="pr-3 opacity-80">{publicationDate}</span>
        <Views />
      </div>
    </>
  );
};

export default PagesByIdAnalyst;
